<template>
    <div class="wrapper">

        <!-- top navbar-->
        <Header />

        <!-- sidebar-->
        <Sidebar />

        <!-- offsidebar-->
        <Offsidebar />

        <!-- Main section-->
        <section class="section-container">
            <!-- Page content-->
            <router-view/>
        </section>

        <!-- Page footer-->
        <Footer />

    </div>
</template>

<script>
    import Header from './Header.vue'
    import Sidebar from './Sidebar.vue'
    import Offsidebar from './Offsidebar.vue'
    import Footer from './Footer.vue'
    import ContentWrapper from './ContentWrapper.vue'

    export default {
        name: 'Layout',
        components: {
            Header,
            Sidebar,
            Offsidebar,
            Footer,
            ContentWrapper
        }
    }
</script>